export class AiChatQueryModel
{
    UserQueries: string[] = [];

    constructor(json: any = null)
    {
        Object.assign(this, json);
    }
}

export class AiChatQueryResponseModel
{
    Queries: string[] = [];
    Responses: string[] = [];
    QueryId: number = -1;

    constructor(json: any = null)
    {
        Object.assign(this, json);
    }
}
